export default __webpack_public_path__ + "static/media/more.6d518c4b.svg";